export default {
  _columns: {
    awaiting_decision: 'Aguardando Decisão',
    canceled: 'Cancelada',
    closed: 'Fechada',
    completed: 'Concluída',
    diagnosis: 'Diagnóstico',
    in_progress: 'Em Progresso',
    lost: 'Perdida',
    negotiation: 'Negociação',
    new: 'Nova',
    proposal: 'Proposta',
    qualification: 'Qualificação',
    won: 'Ganha'
  },
  _cardTypes: {
    opportunity: 'Oportunidade',
    task: 'Tarefa',
  },
  _fields:{
    area_users: 'Usuários da Área',
    area_users_description: 'Combo que traz os usuário disponíveis para essa área do sistema',
    description: 'Descrição',
    qualification: 'Qualificação',
    qualification_description: 'Combo de qualificação do candidato à prospecção',
    qualification_options: ['Frio', 'Morno', 'Quente', 'Venda certa!']
  },
  _groups:{
    general_info: 'Informações Gerais'
  },
  _levels:{
    opportunity: 'Oportunidade',
    task: 'Tarefa'
  },
  _models: {
    agile: 'Ágil',
    sales_pipeline: 'Pipeline de Vendas',
    journey: 'Jornada'
  },
  _pages: {
    name: 'Nome',
    details: 'Detalhes',
  },
  _status: {
    awaiting_decision: 'Aguardando Decisão',
    closed: 'Fechada',
    diagnosis: 'Diagnóstico',
    in_progress: 'Em Progresso',
    lost: 'Perdida',
    negotiation: 'Negociação',
    new: 'Nova',
    proposal: 'Proposta',
    qualification: 'Qualificação',
    won: 'Ganha'
  }

};
